<script setup lang="ts">
import { setOnTheMinuteInterval } from '@/lib/util/dateTime';
import { ref } from 'vue';

const time = ref('');
const date = ref('');

setOnTheMinuteInterval(updateTime, true);

function updateTime() {
  const currentTime = new Date();

  time.value = currentTime
    .toLocaleTimeString('en-AU', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    })
    .toLowerCase();

  date.value = currentTime
    .toLocaleDateString('en-AU', {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
    })
    .replace(',', '');
}
</script>

<template>
  <div class="date-clock">
    <span class="__time"> {{ time }}</span>
    <span class="__date"> {{ date }}</span>
  </div>
</template>

<style scoped>
.date-clock {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  color: var(--co-text-primary);
  flex: 1;
}

.__time {
  font-weight: 500;
  font-size: 30px;
  line-height: 30px;
}

.__date {
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
}

@media (max-width: 1200px) {
  .date-clock {
    flex-direction: row;
    align-items: baseline;
  }

  .__time,
  .__date {
    font-weight: 600;
    font-size: 22px;
    line-height: 20px;
  }

  .__date {
    font-weight: 400;
    font-size: 14px;
  }
}
</style>
